import {useTranslation} from "react-i18next";
import {useRouteNode} from "react-router5";
function EntitiesTrending({setPostTrending, entities, root}) {
  const { t } = useTranslation();

  // sort by total trending desc
  const data = entities.slice().sort((a, b) => b.total_counts - a.total_counts)

  let view;
  let container;

  if(root === "explore"){
    view = <p>{t('Entités')}</p>
  }else{
    view = <p>{t('Entités en tendances')}</p>
  }

  if(data.length !== 0){
    container =  <div className={`c-entities_entityList${ root === "explore" ? "_explore": ''}`}>
        {
          data.map(c => {
            return <Entities entite={c} key={c.id} root={root} setPostTrending={setPostTrending} />
          })
        }
      </div>
  }else{
    container =  <div className={`c-entities_entityList${ root === "explore" ? "_explore": ''}`}>
          <p className="c-message_empty">{t('Aucun éléments à afficher')}</p>
      </div>
  }

  return (
    <>
      <div className={`c-container_entities${ root === "explore" ? "_explore": ''}`}>
        <div className="c-entities_header">
          { view }
        </div>
        { container }

      </div>
    </>
  )
}

function Entities({entite, root, setPostTrending}){
  const { t } = useTranslation();
  const {id,img, name, total_counts} = entite;
  const {router} = useRouteNode('explore');

  let view, span, onClick;

  const navigateToEntity = (id) =>{
    router.navigate('explore.entity',{id:id});
  }

  if(img === null || img === undefined){
    view = <span className="c-entities_img-replace">{name[0].toUpperCase()}</span>
  }else{
    view = <img alt="" className="c-entities_img" style={{width: "40px", height: "40px"}} src={img} />
  }

  if(root === "explore"){
    span = <span className="c-entities_countNews">{total_counts}</span>
    onClick = () => navigateToEntity(id)
  }else{
    span = <span className="c-entities_countNews">{total_counts} {t('articles')}{(total_counts > 1)? 's' : ''}</span>
    onClick = () => setPostTrending(id)
  }

  return (
    <div className={`c-entities_card${ root === "explore" ? "_explore": ''}`} onClick={onClick}>
      { view }
      <p className="c-entities_name">{name}</p>
      { span }
    </div>
  )
}


export default EntitiesTrending
